import * as React from 'react';
import { connect } from 'react-redux';
import logo from '../Content/Images/Logo/Capri_logowS4C-v1.1.png';
import TranscendLogo from '../Content/Images/Logo/Transcend_Colored-v1.1.gif';

export class Footer extends React.PureComponent<any, any> {
    private observer: IntersectionObserver | null = null;
    private initialRender: boolean = true;

    componentDidMount() {
        const footerIsi = document.getElementById('footer-isi');
        const fixedIsi = document.getElementById('fixed-isi');

        if (!footerIsi || !fixedIsi) return;

        // Force display for the fixed ISI on initial page load
        fixedIsi.style.display = 'block';
        this.initialRender = true;

        // Set a flag in session storage to track page loads within this session
        const isFirstLoad = sessionStorage.getItem('hasLoadedPage') !== 'true';
        sessionStorage.setItem('hasLoadedPage', 'true');

        // Create the intersection observer with a slight delay to ensure DOM is ready
        setTimeout(() => {
            this.observer = new IntersectionObserver(
                ([entry]) => {
                    // Always show fixed ISI on the first page load
                    if (isFirstLoad && this.initialRender) {
                        fixedIsi.style.display = 'block';
                        this.initialRender = false;
                        return;
                    }

                    // Normal behavior after initial load
                    if (entry.isIntersecting) {
                        fixedIsi.style.display = 'none';
                        fixedIsi.classList.remove('active');
                        fixedIsi.classList.add('isi-top-inactive');
                    } else {
                        fixedIsi.style.display = 'block';
                    }
                },
                { root: null, threshold: 0.01 }
            );

            this.observer.observe(footerIsi);
        }, 100); // Small delay to ensure DOM is fully loaded
    }


    componentWillUnmount() {
        if (this.observer) {
            this.observer.disconnect();
            this.observer = null;
        }
    }

    render() {
        return (
            <div>

                <div id="footer-isi" style={{ marginTop: "50px", marginBottom: "50px" }}>
                    <div className="container">
                        <div className="footer-isi-title">
                            <h2>INDICATION AND IMPORTANT SAFETY INFORMATION</h2>
                        </div>
                    </div>
                    <div className="container">
                        <div className="footer-isi-content">
                            <div className="must-be-visible">
                                <h3>INDICATION</h3>
                                <p>
                                    ORLADEYO<sup>&reg;</sup> (berotralstat) is a plasma kallikrein inhibitor indicated for prophylaxis to prevent attacks of
                                    hereditary angioedema (HAE) in adults and pediatric patients 12 years and older.
                                </p>
                                <p>
                                    <strong>Limitations of use</strong><br /><br />
                                    The safety and effectiveness of ORLADEYO for the treatment of acute HAE attacks have not been established.
                                    ORLADEYO should not be used for the treatment of acute HAE attacks. Additional doses or dosages of ORLADEYO
                                    higher than 150 mg once daily are not recommended due to the potential for QT prolongation.
                                </p>
                                <h3>IMPORTANT SAFETY INFORMATION</h3>
                                <p className="mb-0">
                                    An increase in QT prolongation was observed at dosages higher than the recommended 150 mg once-daily dosage and was
                                    concentration dependent.
                                </p>

                                <p>
                                    The most common adverse reactions (≥10% and higher than placebo) in patients receiving ORLADEYO were abdominal pain,
                                    vomiting, diarrhea, back pain, and gastroesophageal reflux disease.
                                </p>
                                <p>
                                    A reduced dosage of 110 mg taken orally once daily with food is recommended in patients with moderate or severe hepatic impairment (Child-Pugh B or C).
                                </p>
                                <p>
                                    Berotralstat is a substrate of P-glycoprotein (P-gp) and breast cancer resistance protein. P-gp inducers (eg, rifampin, St. John’s wort) may decrease berotralstat plasma concentration, leading to reduced efficacy of ORLADEYO. The use of P-gp inducers is not recommended with ORLADEYO.
                                </p>
                                <p>
                                    ORLADEYO at a dose of 150 mg is a moderate inhibitor of CYP2D6 and CYP3A4. For concomitant medications with a narrow
                                    therapeutic index that are predominantly metabolized by CYP2D6 or CYP3A4, appropriate monitoring and dose titration
                                    is recommended. ORLADEYO at a dose of 300 mg is a P-gp inhibitor. Appropriate monitoring and dose titration is recommended for P-gp substrates (eg, digoxin) when coadministering with ORLADEYO.
                                </p>
                                <p>
                                    The safety and effectiveness of ORLADEYO in pediatric patients &lt;12 years of age have not been established.
                                </p>
                                <p>
                                    There are insufficient data available to inform drug-related risks with ORLADEYO use in pregnancy. There are no data
                                    on the presence of berotralstat in human milk, its effects on the breastfed infant, or its effects on milk
                                    production.
                                </p>
                                <p>
                               <strong>
                               To report SUSPECTED ADVERSE REACTIONS, contact BioCryst Pharmaceuticals, Inc. at <span style={{color:'#007298'}}>1-833-633-2279</span> or FDA at <span style={{color:'#007298'}}>1-800-FDA-1088</span> or <a href="https://www.fda.gov/safety/medwatch-fda-safety-information-and-adverse-event-reporting-program" rel="noopener" target="_blank">www.fda.gov/medwatch</a>.
                               </strong>
                                </p>
                                <p>
                                    <strong>Please see </strong>
                                    <a target="_blank" href="https://www.biocryst.com/wp-content/uploads/ORLADEYO_USPI.pdf">
                                        <strong>full Prescribing Information</strong></a><strong>.</strong>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <footer className="footer">
                    <div className="row">
                        <div className="column1">
                            <div className="footer_capri">
                                <img src={logo} alt="CAPRI | Sign4compliance Comprehensive Medical Meeting Management System" style={{ width: "200px" }} /><br />
                                <div>
                                    <div>
                                        <span>Powered by:</span>
                                        <span className="footer_capr_sign4compliance_span">CapriMeetingManager.com</span>
                                    </div>

                                    <div className="footer_capr_sign4compliance_div">
                                        <span>Sign4Compliance.com</span>
                                    </div>
                                    <div>
                                        <span>Copyright 2024 Blue Grotto Technologies, Inc.</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="column2">
                            <div style={{ textAlign: "center", fontSize: "13px", margin: "0 auto" }}>
                                <a href="https://www.biocryst.com/terms-and-conditions/" target="_blank">Terms of Use</a>
                                &nbsp;|&nbsp;
                                <a href="https://orladeyo.com/cookie-policy/" target="_blank">Cookie Policy</a>
                                &nbsp;|&nbsp;
                                <a href="https://www.biocryst.com/global-privacy-notice/" target="_blank">Privacy Policy</a>&nbsp;&nbsp;&nbsp;
                            </div>
                            <div style={{ textAlign: "center", marginTop: "40px", fontSize: "12px" }}>
                                <div>
                                    <span>BioCryst and ORLADEYO are registered trademarks of BioCryst Pharmaceuticals, Inc.</span>
                                </div>
                                <div>
                                    <span>&copy;2025 BioCryst Pharmaceuticals, Inc. All rights reserved.</span>
                                </div>
                            </div>
                            <br />
                            <div style={{ border: "2px solid #d3d3d3", color: "#333", width: "280px", padding: "5px 10px", fontSize: "13px", display: "none" }}>
                                These programs are intended to provide information about the first-ever oral prophylactic therapy for people living with hereditary angioedema (HAE).
                            </div>
                        </div>

                        <div className="column3">
                            <div className="footer_managedby">
                                <div>
                                    <span style={{ float: "left", fontSize: "12px" }}>Managed by:</span>
                                </div>
                                <div>
                                    <img src={TranscendLogo} alt="Transcend Medical Communications" width="200" height="90" className="transcendLogo" />
                                    <br />
                                    <div style={{ textAlign: "center" }}>
                                        <a href="https://www.transcendmedcom.com/privacy-policy/" target="_blank" style={{ fontSize: "12px" }}>Privacy Policy</a><br /><br />
                                        <span style={{ fontSize: "12px" }} id="spProjectCode">US.ORL.02433 3/25</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </footer>
            </div >
        );
    }
}
export default connect()(Footer);